import {Component, OnInit, inject} from '@angular/core';

import {MatDialogRef} from '@angular/material/dialog';
import {FeatureFlagQuery} from '../../../common/elf-store/feature-flag/feature-flag.query';
import {AutoUnsubscribe} from '../../../decorators/auto-unsubscribe.decorator';
import {SUBSCRIPTIONS} from '../../../common/utils/constants';
import {FeatureFlagListItem} from '../../../common/elf-store/feature-flag/feature-flag.store';
import {FeatureFlagManager} from '../../../common/elf-store/feature-flag/feature-flag.manager';
import {DialogComponent} from '../../dumb/dialog/dialog.component';

@Component({
  standalone: true,
  selector: 'mc-feature-flag-modal',
  imports: [DialogComponent],
  templateUrl: './feature-flag-modal.component.html',
  styleUrl: './feature-flag-modal.component.scss',
})
@AutoUnsubscribe()
export class FeatureFlagModalComponent implements OnInit {
  dialogRef = inject<MatDialogRef<FeatureFlagModalComponent>>(MatDialogRef);
  private featureFlagManager = inject(FeatureFlagManager);
  private featureFlagQuery = inject(FeatureFlagQuery);

  featureFlagOptions: FeatureFlagListItem[] = [];
  ngOnInit() {
    this[SUBSCRIPTIONS].add(
      this.featureFlagQuery.featureList$.subscribe((response: FeatureFlagListItem[]) => {
        this.featureFlagOptions = response;
      }),
    );
  }

  changeSelection(feature: FeatureFlagListItem): void {
    this.featureFlagManager.toggleFeature(feature.key);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
